import createReactClass from 'create-react-class'
import React from 'react'
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs'
import ReactJson from 'react-json-view'
import ReportTablePanel from './report-table-panel'
import DecisionTreePanel from './decision-tree-panel'
import './report-panel.scss'
import {propEq, filter} from 'ramda'

export default createReactClass({
  getInitialState () {
    return {
      selectedDecisionTree: '', // for dropdown state
      displayedDecisionTree: '', // for displayed decision tree
    }
  },

  componentDidMount () {
    this.props.getDecisionTreeList()
    if (this.props.location.search) {
      let ggsId = this.props.location.search.substring(1)
      this.props.getCompanyReport(ggsId)
    }
  },

  backToSearchPage () {
    this.props.history.push('/search')
  },

  getErrorMessage (error) {
    return error.message ? error.message : (error.messages ? error.messages[0].text : '')
  },

  changeDecisionTree (e) {
    this.setState({selectedDecisionTree: e.target.value})
  },

  getDecisionTree () {
    if (this.props.location.search) {
      let companyId = this.props.location.search.substring(1)
      this.props.getDecisionTreeDetails(this.state.selectedDecisionTree, companyId)
    }
  },

  renderDecisionTreeOptions () {
    return this.props.decisionTree.list.map((tree, index) => {
      return <option key={index} value={tree.GUID}>{tree.friendlyName}</option>
    })
  },

  renderDecisionTree () {
    if (this.props.decisionTree.list && this.props.decisionTree.list.length > 0) {
      return (
        <div className='decision-tree'>
          <select id='decision-tree-select' name="decision-tree" value={this.state.selectedDecisionTree}
            onChange={this.changeDecisionTree}>
            {this.renderDecisionTreeOptions()}
          </select>
          <button className='back-button' onClick={() => {
            this.setState({displayedDecisionTree: this.state.selectedDecisionTree}, () => {
              this.getDecisionTree()
            })
          }}>
            Get Decision
          </button>
        </div>
      )
    }
  },

  getDecisionTreeFriendlyName () {
    const name = filter(propEq('GUID', this.state.displayedDecisionTree), this.props.decisionTree.list)
    return name.length > 0 ? name[0].friendlyName : ''
  },

  render () {
    return (
      <div className="container">
        <div className="report-view-panel">
          {this.props.report.isLoading
            ? <div className='loader-ctr'><span className="loading"></span></div>
            : <div>
              <Tabs>
                <TabList>
                  <button className='back-button' onClick={this.backToSearchPage}>
                    <span className='fa fa-caret-left'/>
                    Back
                  </button>
                  <Tab>Card View</Tab>
                  <Tab>Raw JSON</Tab>
                  {this.renderDecisionTree()}
                </TabList>
                <TabPanel>
                  {this.props.decisionTree.error
                    ? <div>
                      <h4>Decision Tree</h4>
                      <div className="connect-error-alert">{this.getErrorMessage(this.props.decisionTree.error)}</div>
                    </div>
                    : <DecisionTreePanel selectedTree={this.getDecisionTreeFriendlyName()}
                      {...this.props.decisionTree} />}
                  {this.props.report.error
                    ? <div className="connect-error-alert">{this.getErrorMessage(this.props.report.error)}</div>
                    : <ReportTablePanel {...this.props.report} /> }
                </TabPanel>
                <TabPanel>
                  <div>
                    <h4>Decision Tree</h4>
                    <div id='decision-tree-json' className='raw-json-view'>
                      {this.props.decisionTree.dataLoader
                        ? <div className='loader-ctr'><span className="loading"></span></div>
                        : <ReactJson
                          src={this.props.decisionTree.dataError ? this.props.decisionTree.dataError : this.props.decisionTree.decisionTreeData}
                          collapsed={1}/>
                      }
                    </div>
                  </div>
                  <div>
                    <h4>Company Report</h4>
                    <div id='report-json' className='raw-json-view'>
                      <ReactJson src={this.props.report.error ? this.props.report.error : this.props.report.companyReport}
                        collapsed={1}/>
                    </div>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          }
        </div>
      </div>
    )
  },

  componentWillReceiveProps (nextProps) {
    if (this.props.decisionTree.list &&
      this.props.decisionTree.list.length === 0 &&
      nextProps.decisionTree.list.length > 0) {
      this.setState({
        selectedDecisionTree: nextProps.decisionTree.list[0].GUID,
        displayedDecisionTree: nextProps.decisionTree.list[0].GUID,
      }, () => {
        this.getDecisionTree()
      })
    }
  },
})



// WEBPACK FOOTER //
// ./src/components/report-panel.js